import { t, Trans } from '@lingui/macro';
import HelpIcon from '@material-ui/icons/Help';
import PropTypes from 'prop-types';
import ServiceTestAgentSelector from '../ServiceTestAgentSelector';
import { useHelpUrl } from '../../../../../utilities/HelpUtilities';
import NgpRow from '../../../../form/NgpRow';
import TestFormSection from './TestFormSection/TestFormSection';
import useAgents from '../hooks/UseAgents';
import { AgentsContextProvider } from '../hooks/AgentsContextProvider';

const TestRunOnnPointsSection = ({ matchingAgentsRef }) => {
    const {
        wirelessAgents,
        defaultAgents,
        availableAgents,
        matchingTaggedAgents,
        setAvailableAgents,
        setMatchingTaggedAgents,
    } = useAgents();

    const serviceTestnPointConfigurationUrl = useHelpUrl('ServiceTestnPointWi-FiConfigurat');

    return (
        <AgentsContextProvider
            wirelessAgents={wirelessAgents}
            defaultAgents={defaultAgents}
            availableAgents={availableAgents}
            matchingTaggedAgents={matchingTaggedAgents}
            setAvailableAgents={setAvailableAgents}
            setMatchingTaggedAgents={setMatchingTaggedAgents}
        >
            <TestFormSection
                title={<Trans>Run On nPoints</Trans>}
                subText={
                    <NgpRow>
                        <Trans>Only nPoints that meet the test criteria will be available</Trans>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <a
                            href={serviceTestnPointConfigurationUrl}
                            target="_blank"
                            rel="noreferrer"
                            title={t`View help documentation regarding nPoints selection`}
                        >
                            <HelpIcon fontSize="small" />
                        </a>
                    </NgpRow>
                }
            >
                <ServiceTestAgentSelector matchingAgentsRef={matchingAgentsRef} />
            </TestFormSection>
        </AgentsContextProvider>
    );
};

TestRunOnnPointsSection.propTypes = {
    matchingAgentsRef: PropTypes.object,
};

TestRunOnnPointsSection.defaultProps = {
    matchingAgentsRef: undefined,
};

export default TestRunOnnPointsSection;
